import { call, put, retry, takeEvery, takeLatest } from 'redux-saga/effects'
import {
  types,
  ISavePreferenceAction,
  IDeletePreferenceAction,
  ISavePreferenceResponseData,
  IGetPreferenceResponseData,
} from '../types/userPreferences'
import * as actions from '../actions/userPreferences'
import * as services from '../services/userPreferences'
import { trace } from '../services/common'

export const RETRY_MAX_TRIES: number = 5
export const RETRY_DELAY_LENGTH: number = 200

export function* saveUserPreferenceSaga({ groupId, fieldName, fieldValue, updateMode }: ISavePreferenceAction) {
  try {
    const preferenceResponseData: ISavePreferenceResponseData | IGetPreferenceResponseData = yield retry(
      RETRY_MAX_TRIES,
      RETRY_DELAY_LENGTH,
      updateMode ? services.updateUserPreference : services.saveUserPreference,
      services.transformStateToUserPreference(groupId, fieldName, fieldValue)
    )
    yield put(actions.saveUserPreferenceSuccess(
      groupId,
      services.transformUserPreferenceToState(preferenceResponseData)
    ))
  } catch (err) {
    trace(err)
  }
}

export function* getUserPreferencesSaga() {
  try {
    const preferencesResponseData: IGetPreferenceResponseData[] = yield call(services.getUserPreferences)
    yield put(actions.getUserPreferencesSuccess(services.transformUserPreferencesToState(preferencesResponseData)))
  } catch (err) {
    yield put(actions.getUserPreferencesFailure())
    trace(err)
  }
}

export function* deleteUserPreferenceSaga(
  { groupId, fieldName }: IDeletePreferenceAction
) {
  try {
    yield retry(
      RETRY_MAX_TRIES,
      RETRY_DELAY_LENGTH,
      services.deleteUserPreference,
      services.generateUserPreferenceKey(groupId, fieldName)
    )
    yield put(actions.deleteUserPreferenceSuccess(groupId, fieldName))
  } catch (err) {
    trace(err)
  }
}

export function* userPreferencesWatcher() {
  yield takeEvery(types.SAVE_PREFERENCE__STARTED, saveUserPreferenceSaga)
  yield takeLatest(types.GET_PREFERENCES__STARTED, getUserPreferencesSaga)
  yield takeEvery(types.DELETE_PREFERENCE__STARTED, deleteUserPreferenceSaga)
}
